<template>
  <div>
    <template v-if="ready">
      <div
        v-once
        id="amzn-buy-now"
        :data-site-id="siteId"
        :data-widget-id="widgetId"
        :data-sku="sku"
      ></div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BuyWithPrime',

  props: {
    sku: {
      default: null,
      type: String
    }
  },

  data() {
    return {
      siteId: process.env.buyWithPrimeSiteId,
      widgetId: process.env.buyWithPrimeWidgetId,
      observer: null
    }
  },

  computed: {
    ready() {
      return !!(this.sku && this.siteId && this.widgetId)
    }
  },

  watch: {
    ready(next) {
      if (next) {
        this.setupWidget()
      }
    }
  },

  mounted() {
    window.bwp = undefined
    window.bwpCartScriptLoadedOn = undefined
    if (this.ready) {
      this.setupWidget()
    }
  },

  beforeDestroy() {
    try {
      window.bwp?.disableWidget()
    } catch (error) {
      if (error.message === 'bwp widget has not been created yet') {
        // TD - Ignore this error as it's expected for products
        // that don't have the BWP button displayed.
      } else {
        // Re-throw the error if it's something else.
        throw error
      }
    }
    window.bwp = undefined
    window.bwpCartScriptLoadedOn = undefined
    this.observer?.disconnect()
    this.$emit('widgetdestroyed')
  },

  methods: {
    setupWidget() {
      this.observer = new MutationObserver((records, observer) => {
        const isSetup = this.$el.querySelector('iframe')?.clientHeight > 0
        if (isSetup) {
          observer.disconnect()
          this.$emit('widgetloaded')
        }
      })

      this.observer.observe(this.$el, {
        attributes: true,
        childList: true,
        subtree: true
      })

      let script = document.scripts.namedItem('recess-buy-with-prime')

      if (!script) {
        script = document.createElement('script')
        Object.assign(script, {
          async: true,
          fetchPriority: 'high',
          id: 'recess-buy-with-prime',
          src: 'https://code.buywithprime.amazon.com/bwp.v1.js'
        })
        this.$el.append(script)
      }

      try {
        window.bwp?.updateWidget?.(this.sku)
      } catch (error) {
        if (error.message === 'bwp widget has not been created yet') {
          // Ignore
        } else {
          throw error
        }
      }
    }
  }
}
</script>
